import { render, staticRenderFns } from "./s-audio.vue?vue&type=template&id=934d6a00&scoped=true&"
import script from "./s-audio.vue?vue&type=script&lang=js&"
export * from "./s-audio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934d6a00",
  null
  
)

export default component.exports